























































































































































import { Vue, Component, Prop, Emit, Ref } from 'vue-property-decorator';
import { toStyleVal, isNumeric } from '@/utils';
import * as I from '@/interfaces';
import * as E from '@/enums';
import AxMonitorContext from './AxMonitorContext.vue';
import AxMonitorAllContext from './AxMonitorAllContext.vue';

class State {
  doorStatus: number;
  isConnected: boolean;
  constructor() {
    this.doorStatus = 0;
    this.isConnected = false;
  }

  get isFire() {
    if (this.doorStatus === 160) {
      return true;
    } else {
      return false;
    }
  }

  get isAdminOpen() {
    if (this.doorStatus === 131 || this.doorStatus === 150) {
      return true;
    } else {
      return false;
    }
  }

  get isAdminClose() {
    if (this.doorStatus === 161 || this.doorStatus === 133 || this.doorStatus === 152) {
      return true;
    } else {
      return false;
    }
  }

  get isSchedule() {
    if (this.doorStatus === 150 || this.doorStatus === 152) {
      return true;
    } else {
      return false;
    }
  }
}

@Component
export default class AxMonitorGrid extends Vue {
  @Prop()
  door!: I.MonitorDoor;

  @Prop()
  sensor!: I.MonitorSensor;

  @Ref()
  context!: AxMonitorContext;

  @Ref()
  contextall!: AxMonitorAllContext;

  oldDoorStatus = 0;
  newDoorStatus = 0;

  listEvent: I.MonitorSimpleEvent[] = [];
  state = new State();

  AddEvent(event: I.MonitorSimpleEvent) {
    console.log(event);
    this.listEvent.splice(0, 0, event);
    if (this.listEvent.length > 2) {
      this.listEvent.splice(this.listEvent.length - 1, 1);
    }
  }

  onDoorControl(doorid: number, controlcode: number) {
    console.log(this.$parent);
    this.$emit('onOpenClick', doorid, controlcode);
  }

  onDoorAllControl(doorid: number, controlcode: number) {
    console.log(this.$parent);
    this.$emit('onOpenAllClick', doorid, controlcode);
  }

  GetUserName(event: I.MonitorSimpleEvent) {
    if (event) {
      return `${event.name} [${event.companyName}]`;
    } else {
      return '';
    }
  }

  Photo(event: I.MonitorSimpleEvent) {
    if (event.photo) {
      return 'data:image/png;base64, ' + event.photo;
    } else {
      return require('../../assets/user/user_photo.png');
    }
  }

  BottomClick(e: MouseEvent) {
    console.log('button' + e.button);
    console.log('door' + this.door.doorID);
    if (this.context) {
      this.contextall.Hide(e);
      this.context.Show(e, this.door.doorID);
    }
  }

  BottomAllClick(e: MouseEvent) {
    console.log('button' + e.button);
    console.log('door' + this.door.doorID);
    if (this.contextall) {
      this.context.Hide(e);
      this.contextall.Show(e, this.door.doorID);
    }
  }

  HidenClick(e: MouseEvent) {
    console.log('button' + e.button);
    if (this.context) {
      this.contextall.Hide(e);
      this.context.Hide(e);
    }
  }

  HidenAllClick(e: MouseEvent) {
    console.log('button' + e.button);
    if (this.contextall) {
      this.context.Hide(e);
      this.contextall.Hide(e);
    }
  }

  get isError() {
    if (this.listEvent.length > 0) {
      if (this.listEvent[0].eventCode >= E.EDeviceEventCode.AUTH_ERR_UNREGISTERED_MEDIA)
        return true;
    }
    return false;
  }

  get doorName() {
    if (this.door) {
      return this.door.name;
    } else {
      return '';
    }
  }

  get doorClass() {
    switch (this.state.doorStatus) {
      case 0: //기본
      case 104: //닫힘
      case 161: //화제 폐쇄
      case 102: //열림
      case 160: //화재 개방
      case 103: //계속 열림
      case 105: //강제로 열림
      case 106: //강제로 계속 열림
        this.oldDoorStatus = this.state.doorStatus;
        this.newDoorStatus = this.state.doorStatus;
        break;
      default:
        this.newDoorStatus = this.oldDoorStatus;
    }

    switch (this.newDoorStatus) {
      case 0: //기본
      case 104: //닫힘
      case 161: //화제 폐쇄
        return 'close';
        break;
      case 102: //열림
      case 160: //화재 개방
        return 'open';
        break;
      case 103: //계속 열림
        return 'open-keep';
        break;
      case 105: //강제로 열림
        return 'open-force';
        break;
      case 106: //강제로 계속 열림
        return 'open-keep-force';
        break;
    }
  }
}
